import React from 'react'
import {Route, Switch} from "react-router-dom";


const AuthScreen = (props) => {
    return (
        <Switch>
            <Route>
                {props.children}
            </Route>
        </Switch>
    )
}

export default AuthScreen